import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';
import { defaultMST1010_R01Dto, MST1010_R01Dto } from './Dto_MST1010_R01';
import { allCd, useCommonCodeStore } from 'src/store/useCommonCodeStore';

export interface MST1010_R01Filter {
	brandCd: string;
	itemGroup: string;
	itemAccount: string;
	itemCd: string;
	itemNm: string;
}

export interface Store_MST1010_R01 {
	MST1010_R01Filter: MST1010_R01Filter;
	MST1010_R01PastFilter: MST1010_R01Filter;
	setMST1010_R01Filter: (filter: Partial<MST1010_R01Filter>) => void;
	setMST1010_R01PastFilter: (filter: Partial<MST1010_R01Filter>) => void;

	MST1010_R01List: MST1010_R01Dto[];
	setMST1010_R01List: (MST1010_R01List: MST1010_R01Dto[]) => void;

	selectedMST1010_R01: MST1010_R01Dto | undefined;
	setSelectedMST1010_R01: (item: MST1010_R01Dto | undefined) => void;
	initSelectedMST1010_R01: () => void;

	editMST1010_R01: MST1010_R01Dto | null;
	setEditMST1010_R01: (item: MST1010_R01Dto | null) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultMST1010_R01Filter : MST1010_R01Filter = {
	brandCd: '',
	itemGroup: '',
	itemAccount: '',
	itemCd: '',
	itemNm: '',
};

export const useMST1010_R01Store = create<Store_MST1010_R01>((set) => ({
	MST1010_R01Filter: defaultMST1010_R01Filter,
	MST1010_R01PastFilter: defaultMST1010_R01Filter,
	setMST1010_R01Filter: (filter: Partial<MST1010_R01Filter>) => set((state) =>  ({
		...state,
		MST1010_R01Filter: {
			...state.MST1010_R01Filter,
			...filter
		}	
	})),
	setMST1010_R01PastFilter: (filter: Partial<MST1010_R01Filter>) => set((state) =>  ({
		...state,
		MST1010_R01PastFilter: {
			...state.MST1010_R01PastFilter,
			...filter
		}	
	})),

	MST1010_R01List: [],
	setMST1010_R01List: (MST1010_R01List: MST1010_R01Dto[]) => set({ MST1010_R01List }),

	selectedMST1010_R01: undefined,
	setSelectedMST1010_R01: (item: MST1010_R01Dto | undefined) => set((state) => {

		return { ...state, selectedMST1010_R01: item };
	}),
	initSelectedMST1010_R01: () => set({ selectedMST1010_R01: undefined, editMST1010_R01: defaultMST1010_R01Dto }),
	
	editMST1010_R01: defaultMST1010_R01Dto,
	setEditMST1010_R01: (item: MST1010_R01Dto | null) => set((state) => {
		let editData = defaultMST1010_R01Dto;
		if (item) {
			editData = { ...item };
		}
		return { editMST1010_R01: editData };
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	initData: () => set((state) => ({
		...state,
		MST1010_R01Filter: defaultMST1010_R01Filter,
		MST1010_R01PastFilter: defaultMST1010_R01Filter,
		selectedMST1010_R01: undefined,
		editMST1010_R01: defaultMST1010_R01Dto,
		MST1010_R01List: [],
		allCount: 0,
		scrollTop: null,
	})),

	
}));
